import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import { UserModule } from '@/store/modules/user'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useSegment from '@/composables/useSegment'
  import useBreakpoint from '@/composables/useBreakpoint'
  import GoogleReviewWidget from '@/components/GoogleReviewWidget.vue'
  import type { Socials } from '@/services/interfaces/Auth0'
  import IDDMinutesWidget from '@/components/IDDMinutesWidget.vue'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyHeaderSection',
  setup(__props) {

  const { curvedArrowLeft } = useIcons()
  const { socialMediaClicked } = useSegment()
  const { isSmallerMobileDevice, isDesktopDevice } = useBreakpoint()
  const { isSachkundeCompany } = useCommonMixin()

  const companyImageUrl = computed(() => UserModule.headerImageUrl)

  const headerTitle = computed(() => UserModule.currentCompany?.headerTitle)
  const headerSubtitle = computed(() => UserModule.currentCompany?.headerSubtitle)
  const companySocialProperties = computed(() => UserModule.currentCompany?.socialMedia)

  const displayIcon = computed(() => {
    return (name: Socials) => {
      if (name === 'Facebook') return require('@/assets/images/facebook.svg')
      if (name === 'Instagram') return require('@/assets/images/instagram.svg')
      if (name === 'LinkedIn') return require('@/assets/images/linkedin.svg')
      if (name === 'Youtube') return require('@/assets/images/youtube.svg')
      if (name === 'Xing') return require('@/assets/images/xing-icon.svg')
      if (name === 'TikTok') return require('@/assets/images/tik_tok.svg')
      return ''
    }
  })

  const trackCompanySocialClick = (social: Socials) => {
    socialMediaClicked(UserModule.currentCompany!.id, UserModule.currentCompany!.name, social)
  }

return { __sfc: true,curvedArrowLeft, socialMediaClicked, isSmallerMobileDevice, isDesktopDevice, isSachkundeCompany, companyImageUrl, headerTitle, headerSubtitle, companySocialProperties, displayIcon, trackCompanySocialClick, computed, UserModule, SVGRenderer, useIcons, useSegment, useBreakpoint, GoogleReviewWidget, IDDMinutesWidget, useCommonMixin }
}

})